import "./ClearImageButton.css";

const ClearImageButton = ({ onClick, title }) => {
  return (
    <button
      className="clear-image-btn"
      onClick={onClick}
      title={title || "Удалить изображение"}
    >
      ×
    </button>
  );
};

export default ClearImageButton;
